import React from "react";
import {reduxForm} from "redux-form/immutable";
import OrderBasicInfo from "../../../dashboard/views/warehouses/OrderBasicInfo";
import {getPackageUID, withWarehousePackages} from "../../../lib/WarehouseHelper";
import PackageWithTracking from "../../../dashboard/views/warehouses/PackageWithTracking";
import styles from "./OrderDetailForm.module.scss";
import PackageActions from "../../../dashboard/views/warehouses/actions/PackageActions";
import Cell from "../../../dashboard/views/warehouses/Cell";

const OrderDetailForm = (props) => {
  const { warehouseId, jobId, jobPackages} = props;

  const job = props.getJobById(jobId);

  let headerActions = (
    <PackageActions
      warehouseId={warehouseId}
      jobId={jobId}
      packages={jobPackages}
      detailView
    />
  );

  const packagesElems = jobPackages.map((p) => {
    return (
      <PackageWithTracking key={getPackageUID(p)}
        pack={p}
        warehouseId={warehouseId}
        className="bg-secondary"
        withState
        detailView
      />
    );
  });

  const headerTitle = (
    <OrderBasicInfo warehouseId={warehouseId} name={job.recipientName}
      address={job.recipient} withAddress noPadding
      jobId={jobId} orgOrderId={job.orgOrderId} packages={jobPackages} compact={false}
      orderDetail={true}
    />
  );
  const headerAction = (
    <div className={styles.actions}>
      { headerActions }
      { props.getTagsForJobId(jobId) }
    </div>
  );
  
  return (
    <Cell
      className={styles.header}
      title={headerTitle}
      actions={headerAction}
      alert={props.getAlertInfoForJobId(jobId)}
      detailView>
      { packagesElems }
    </Cell>
  );
}

const ReduxForm = reduxForm({
  form: "OrderDetailForm"
})(OrderDetailForm);

export default withWarehousePackages(ReduxForm);